import React, { Component } from 'react';
import {Row, Col, Button, TextInput} from 'react-materialize'

import {connect} from 'react-redux'
import { compose } from 'redux';
import {withRouter} from 'react-router-dom'

import {addAppointment} from '../../store/actions/appointmentActions.js'
import ErrorCard from './ErrorCard.js'
import ServicesList from './ServicesList.js'
import StylistList from './StylistList.js'

import './Schedule.css'

class Schedule extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: '',
      lastName: '',
      services: [],
      stylist: '',
      date: '',
      time: '',
      serviceOptions: false,
      stylistOptions: false,
      foundError: false,
      errors: {}
    }
  }
  disableDayHandler = () => {
    console.log('disable sundays');
    //disable sundays
    //disable previus days from today or only choose days from today and onward (including time)
  }
  /*
  * Remove errors from state when input field changes
  * Used to remove errors displayed on page
  */
  removeErrors(elementName) {
    let errors = {...this.state.errors};
    if (this.state.foundError) {
      delete errors[elementName];
    }
    return errors;
  }
  /*
  * updates state when input field changes
  * used on text inputs and select
  */
  inputHandler = (event) => {
    const elementName = event.target.id;
    const elementValue = event.target.value;
    let errors = this.removeErrors(elementName);
    this.setState({
      [elementName]: elementValue,
      errors: errors
    })
  }

  /*
  * updates state when date or time input field changes
  */
  dateTimeHandler = (event) => {
    event.preventDefault();
    const elementName = event.target.id;
    const elementValue = event.target.value;
    let errors = this.removeErrors(elementName);
    this.setState({
      [elementName]: elementValue,
      errors: errors
    }, () => {
      // Reveal next section of form when date and time have been selected
      if (this.state.time.length > 0 && this.state.date.length > 0)
      this.setState({ serviceOptions: true })
    });
  }
  /*
  * updates state when checkboxes changes
  */
  checkboxHandler = (value, quantity, check = true) => {
    let servicesArray = this.addServiceQuantity(value, quantity, check);
    let errors = this.removeErrors('services');
    this.setState({
      services: servicesArray,
      errors: errors
    }, () => {
      // Reveal next section of form when at least 1 checkbox have been selected
      if (this.state.services.length > 0)
      this.setState({ stylistOptions: true })
    })
  }
  /*
  * checks if the service has been previously selected 
  * if selected, just add quantity
  * else, add the service and quantity to service array
  * returns array of services w/ quantity
  */
  addServiceQuantity(value, quantity, check = true) {
    let servicesArray = [];
    let foundService = this.state.services.find(service => service.type === value);
   
    if (foundService) {
      foundService.quantity = quantity;
      let newServices = this.state.services.filter(service => service.type !== value);
      //check if the checkbox was unchecked
      if (check === false){
        servicesArray = [...newServices]
      }
      // add if checked
      else {
        servicesArray = [...newServices, foundService]
      }
    }
    else {
      servicesArray = [...this.state.services, {type: value, quantity: quantity}];
    }
    return servicesArray;
  }
  /*
  * on submit, form validation
  * if error is found add message to state.errors array (used to display feedback messages)
  * else save appointment
  */
  submitHandler = (event) => {
    let foundError = Object.keys(this.state.errors).length > 0 ? true : false;
    let errors = {};// re-check for errors on submit
    //validation
    if (this.state.firstName.length <= 0) {
      foundError = true;
      errors.firstName = 'Please enter your first name';
    }
    else if (this.state.lastName.length <= 0) {
      foundError = true;
      errors.lastName = 'Please enter your last name';
    }
    else if (this.state.date.length <= 0) {
      foundError = true;
      errors.date = 'Please choose a date with mm/dd/yyyy format. Ex. 12/02/2020';
    }
    else if (this.state.time.length <= 0) {
      foundError = true;
      errors.time = 'Please choose a time. Ex. 03:00 PM';
    }
    else if (this.state.services.length <= 0) {
      foundError = true;
      errors.services = 'Please choose at least 1 service';
    }
    else if (this.state.stylist.length <= 0) {
      foundError = true;
      errors.stylist = 'Please choose a stylist';
    }

    if (foundError) {
      return this.setState({foundError: true, errors: errors});
    }
    else {
      return this.setState({ foundError: false }, () => {
        //save appointment
        this.props.addAppointment(this.state);
        this.props.history.push('/');
      })
    }
  }
  render() {
    const {errors} = this.state;
    return (
      <div>
        <header className="header_banner">
          <div className="header_content">
            <h1 className="amber-text text-darken-4">Schedule an Appointment</h1>
          </div>
        </header>

        <main className="container">
          { errors.firstName && (<ErrorCard errorText={errors.firstName}></ErrorCard>) }
          { errors.lastName && (<ErrorCard errorText={errors.lastName}></ErrorCard>) }
          <Row>
            <Col s={12} m={6}>
              <div className="input-field">
                <TextInput id="firstName" label="First Name" onChange={this.inputHandler} />
              </div>
            </Col>
            <Col s={12} m={6}>
              <div className="input-field">
                <TextInput id="lastName" label="Last Name" onChange={this.inputHandler} />
              </div>
            </Col>
          </Row>
          { errors.date && (<ErrorCard errorText={errors.date}></ErrorCard>) }
          { errors.time && (<ErrorCard errorText={errors.time}></ErrorCard>) }
          <Row>
            <Col s={12} m={6}>
              <div className="input-field">
                <input type="date" id="date" onChange={this.dateTimeHandler} />
                <label htmlFor="date">Date</label>
              </div>
            </Col>
            <Col s={12} m={6}>
              <div className="input-field">
                <input type="time" id="time" onChange={this.dateTimeHandler} />
                <label htmlFor="time">Time</label>
                <span className="helper-text" data-error="Invalid date" data-success="Great">ex. 03:00 PM</span>
                </div>
            </Col>
          </Row>
          { errors.services && (<ErrorCard errorText={errors.services}></ErrorCard>) }
          <ServicesList selectedDate={this.state.date} selectedTime={this.state.time} serviceOptions={this.state.serviceOptions} checkboxHandler={this.checkboxHandler} />

          { errors.stylist && (<ErrorCard errorText={errors.stylist}></ErrorCard>) }
          <StylistList stylistOptions={this.state.stylistOptions} services={this.state.services} inputHandler={this.inputHandler} />

          <Button className={"btn waves-effect waves-orange btn_primary btn_primary-submit " + (Object.keys(this.state.errors).length > 0 ? 'disabled' : '')} onClick={this.submitHandler}>Set Appointment</Button>
        </main>
        <br /><br />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    addAppointment: (data) => dispatch(addAppointment(data))
  }
}

export default compose(
  connect(null, mapDispatchToProps),
  withRouter
  )(Schedule)
